module.exports = __webpack_public_path__ + "assets/images/magenta_sport_2.ed3194c676830b2b55d1552907041c76.png";